import { RawMetalListComponent } from './Component/Auth/raw-metal/raw-metal-list/raw-metal-list.component';
import { ImitationStockB2Component } from './Component/Auth/stock/retail-imitation-stock/imitation-stock-b2/imitation-stock-b2.component';
import { SinglevoucherComponent } from './Component/Voucher/singlevoucher/singlevoucher.component';
import { Routes, CanActivateFn } from '@angular/router';
import { LoginComponent } from './Component/Unauth/login/login.component';
import { SignupComponent } from './Component/Unauth/signup/signup.component';
import { HomeComponent } from './Component/home/home.component';
import { authGuardGuard, CAGuard, kalakarGuard } from './auth-guard.guard';
import { UserListComponent } from './Component/User/user-list/user-list.component';
import { UserEditComponent } from './Component/User/user-edit/user-edit.component';
import { UserCreateComponent } from './Component/User/user-create/user-create.component';
import { PackageShowComponent } from './Component/Package/package-show/package-show.component';
import { PackageCreateComponent } from './Component/Package/package-create/package-create.component';
import { PackageEditComponent } from './Component/Package/package-edit/package-edit.component';
import { SinglepackageShowComponent } from './Component/Package/singlepackage-show/singlepackage-show.component';
import { CountryShowComponent } from './Component/Core/Country/country-show/country-show.component';
import { CountryEditComponent } from './Component/Core/Country/country-edit/country-edit.component';
import { CountryCreateComponent } from './Component/Core/Country/country-create/country-create.component';
import { StatesShowComponent } from './Component/Core/States/states-show/states-show.component';
import { StatesEditComponent } from './Component/Core/States/states-edit/states-edit.component';
import { StatesCreateComponent } from './Component/Core/States/states-create/states-create.component';
import { CitiesShowComponent } from './Component/Core/Cities/cities-show/cities-show.component';
import { CitiesEditComponent } from './Component/Core/Cities/cities-edit/cities-edit.component';
import { CitiesCreateComponent } from './Component/Core/Cities/cities-create/cities-create.component';
import { OwnerShowComponent } from './Component/Owner/owner-show/owner-show.component';
import { OwnerCreateComponent } from './Component/Owner/owner-create/owner-create.component';
import { OwnerEditComponent } from './Component/Owner/owner-edit/owner-edit.component';
import { OwnerSingleComponent } from './Component/Owner/owner-single/owner-single.component';
import { ForgotPasswordComponent } from './Component/Unauth/forgot-password/forgot-password.component';
import { VerifyOtpComponent } from './Component/Unauth/verify-otp/verify-otp.component';
import { UpdatePasswordComponent } from './Component/Unauth/update-password/update-password.component';
import { ValidateOtpComponent } from './Component/Unauth/validate-otp/validate-otp.component';
import { UnauthenticatedLayoutComponent } from './Component/Unauth/unauthenticated-layout/unauthenticated-layout.component';
import { FirmListComponent } from './Component/Firm/firm-list/firm-list.component';
import { EditvoucherComponent } from './Component/Voucher/editvoucher/editvoucher.component';
import { VoucherlistComponent } from './Component/Voucher/voucherlist/voucherlist.component';
import { CreatevoucherComponent } from './Component/Voucher/createvoucher/createvoucher.component';
import { FirmCreateComponent } from './Component/Firm/firm-create/firm-create.component';
import { AddStockComponent } from './Component/Auth/stock/add-stock/add-stock.component';
import { SellComponent } from './Component/Auth/sell/sell.component';

import { CreateUserComponent } from './Component/Auth/user/create-user/create-user.component';
import { AddCustomerComponent } from './Component/Auth/user/add-customer/add-customer.component';
import { AddStaffComponent } from './Component/Auth/user/add-staff/add-staff.component';
import { AddSupplierComponent } from './Component/Auth/user/add-supplier/add-supplier.component';
import { AddInvestorComponent } from './Component/Auth/user/add-investor/add-investor.component';
import { AlluserListComponent } from './Component/Auth/user/alluser-list/alluser-list.component';
import { CustomerListComponent } from './Component/Auth/user/customer-list/customer-list.component';
import { StaffListComponent } from './Component/Auth/user/staff-list/staff-list.component';
import { SupplierListComponent } from './Component/Auth/user/supplier-list/supplier-list.component';
import { InvestorListComponent } from './Component/Auth/user/investor-list/investor-list.component';

import { TestFileUploadComponent } from './Component/test-file-upload/test-file-upload.component';
import { StockFeatureComponent } from './Component/Auth/stock/stock-feature/stock-feature.component';

import { AddReadyProductComponent } from './Component/Auth/stock/add-ready-product/add-ready-product.component';
import { GeneralListComponent } from './Component/Auth/stock/general-list/general-list.component';
import { RateListGeneratorComponent } from './Component/Auth/rate-list/rate-list-generator/rate-list-generator.component';
import { GeneratedRatelistComponent } from './Component/Auth/rate-list/generated-ratelist/generated-ratelist.component';
import { RawMetalEntryComponent } from './Component/Auth/raw-metal/raw-metal-entry/raw-metal-entry.component';
import { MetalComponent } from './Component/Auth/raw-metal/metal/metal.component';
import { StoneComponent } from './Component/Auth/raw-metal/stone/stone.component';
import { TagListComponent } from './Component/Auth/tag/tag-list/tag-list.component';
import { AssembleProductComponent } from './Component/Auth/tag/assemble-product/assemble-product.component';
import { FineProductComponent } from './Component/Auth/tag/fine-product/fine-product.component';
import { CreateTagComponent } from './Component/Auth/tag/create-tag/create-tag.component';
import { AssembleTaglistComponent } from './Component/Auth/tag/assemble-taglist/assemble-taglist.component';
import { FineTaglistComponent } from './Component/Auth/tag/fine-taglist/fine-taglist.component';
import { ForbiddenComponent } from './Component/Core/error/forbidden/forbidden.component';
import { NotFoundComponent } from './Component/Core/error/not-found/not-found.component';
import { CategoriesListComponent } from './Component/Auth/stock/categories-list/categories-list.component';
import { StaffDashboardComponent } from './Component/Auth/rmportal/staff-dashboard/staff-dashboard.component';
import { SalesTargetComponent } from './Component/Auth/rmportal/home/sales-target/sales-target.component';
import { IncentivesComponent } from './Component/Auth/rmportal/home/incentives/incentives.component';
import { TopDetailsComponent } from './Component/Auth/rmportal/home/top-details/top-details.component';
import { StaffHomeComponent } from './Component/Auth/rmportal/home/staff-home/staff-home.component';
import { StockOverviewComponent } from './Component/Auth/rmportal/home/stock-overview/stock-overview.component';
import { AddFineStockB1Component } from './Component/Auth/stock/retail-fine-stock/add-fine-stock-b1/add-fine-stock-b1.component';
import { AddFineStockB2Component } from './Component/Auth/stock/retail-fine-stock/add-fine-stock-b2/add-fine-stock-b2.component';
import { AddFineStockB3Component } from './Component/Auth/stock/retail-fine-stock/add-fine-stock-b3/add-fine-stock-b3.component';

import { AddCadStockComponent } from './Component/Auth/stock/retail-fine-stock/add-cad-stock/add-cad-stock.component';
import { AddMetalFormB2Component } from './Component/Auth/stock/retail-fine-stock/add-metal-form-b2/add-metal-form-b2.component';
import { ProductCreationComponent } from './Component/Auth/stock/product-creation/product-creation.component';
import { ReadyProductListComponent } from './Component/Auth/stock/ready-product-list/ready-product-list.component';
import { ProductEditComponent } from './Component/Auth/stock/product-edit/product-edit.component';
import { CustomizeFormComponent } from './customize-form/customize-form.component';
import { RawStoneListComponent } from './Component/Auth/raw-metal/raw-stone-list/raw-stone-list.component';
import { CreateReportComponent } from './Component/Auth/report/create-report/create-report.component';
import { FineJewelleryComponent } from './Component/Auth/report/fine-jewellery/fine-jewellery.component';
import { RawMetalComponent } from './Component/Auth/report/raw-metal/raw-metal.component';
import { RawMetalStockComponent } from './Component/Auth/report/raw-metal-stock/raw-metal-stock.component';
import { StockTallyComponent } from './Component/Auth/report/stock-tally/stock-tally.component';
import { ReorderListComponent } from './Component/Auth/report/reorder-list/reorder-list.component';
import { OtherPanelComponent } from './Component/Auth/report/other-panel/other-panel.component';
import { AddWholesaleStockB1Component } from './Component/Auth/stock/wholsale-fine-stock/add-wholesale-stock-b1/add-wholesale-stock-b1.component';
import { AddWholesaleStockB2Component } from './Component/Auth/stock/wholsale-fine-stock/add-wholesale-stock-b2/add-wholesale-stock-b2.component';
import { AddWholesaleStockB3Component } from './Component/Auth/stock/wholsale-fine-stock/add-wholesale-stock-b3/add-wholesale-stock-b3.component';


import { ImitationStockB1Component } from './Component/Auth/stock/retail-imitation-stock/imitation-stock-b1/imitation-stock-b1.component';
import { ImitationStockB3Component } from './Component/Auth/stock/retail-imitation-stock/imitation-stock-b3/imitation-stock-b3.component';
import { ImitationFashionJewelleryComponent } from './Component/Auth/stock/retail-imitation-stock/imitation-fashion-jewellery/imitation-fashion-jewellery.component';
import { ImitationJewelleryComponent } from './Component/Auth/report/imitation-jewellery/imitation-jewellery.component';
import { AddSterlingJewelleryStockComponent } from './Component/Auth/stock/retail-imitation-stock/add-sterling-jewellery-stock/add-sterling-jewellery-stock.component';

import { WholsaleImitationStockB1Component } from './Component/Auth/stock/wholsale-imitation-stock/wholsale-imitation-stock-b1/wholsale-imitation-stock-b1.component';
import { WholsaleImitationStockB2Component } from './Component/Auth/stock/wholsale-imitation-stock/wholsale-imitation-stock-b2/wholsale-imitation-stock-b2.component';
import { WholsaleImitationStockB3Component } from './Component/Auth/stock/wholsale-imitation-stock/wholsale-imitation-stock-b3/wholsale-imitation-stock-b3.component';
import { WholsaleImitationFashionJewelleryComponent } from './Component/Auth/stock/wholsale-imitation-stock/wholsale-imitation-fashion-jewellery/wholsale-imitation-fashion-jewellery.component';
import { WholsaleImitationAddSterlingJewelleryStockComponent } from './Component/Auth/stock/wholsale-imitation-stock/wholsale-imitation-add-sterling-jewellery-stock/wholsale-imitation-add-sterling-jewellery-stock.component';

import { AddFineStockB1ScrollComponent } from './Component/Auth/stock/retail-fine-stock/add-fine-stock-b1-scroll/add-fine-stock-b1-scroll.component';
import { AvailableRetailStockListComponent } from './Component/Auth/stock/available-retail-stock-list/available-retail-stock-list.component';
import { DropdownSettingComponent } from './Component/Customize-Dropdown/dropdown-setting/dropdown-setting.component';
import { StockInListComponent } from './Component/Auth/stock/stock-in-list/stock-in-list.component';
import { StockOutListComponent } from './Component/Auth/stock/stock-out-list/stock-out-list.component';
import { PackagingFormComponent } from './Component/Auth/stock/packaging-form/packaging-form.component';
import { PackagingListComponent } from './Component/Auth/report/packaging-list/packaging-list.component';
import { AssigneComponent } from './Component/Auth/stock/assigne/assigne.component';
import { OrderCreationComponent } from './Component/Auth/stock/order-creation/order-creation.component';
import { DesignProductComponent } from './Component/Auth/stock/design-product/design-product.component';
import { OrdersCreationComponent } from './Component/Auth/stock/orders-creation/orders-creation.component';
import { KalakaarManagementComponent } from './Component/Auth/kalakaar/kalakaar-management/kalakaar-management.component';
import { AccountComponent } from './Component/Auth/kalakaar/account/account.component';
import { OrderComponent } from './Component/Auth/kalakaar/order/order.component';
import { RawMaterialComponent } from './Component/Auth/kalakaar/raw-material/raw-material.component';
import { KalakaarHomeComponent } from './Component/Auth/kalakaar/kalakaar-home/kalakaar-home.component';
import { AvailableToProduceComponent } from './Component/Auth/available-to-produce/available-to-produce.component';
import { MaterialRequirementSheetComponent } from './Component/Auth/material-requirement-sheet/material-requirement-sheet.component';
import { ComboCreationComponent } from './Component/Auth/combo-creation/combo-creation.component';
import { ProductTaggingComponent } from './Component/Auth/tag/product-tagging/product-tagging.component';
import { ReadyProductLotComponent } from './Component/Auth/stock/ready-product-lot/ready-product-lot.component';
import { ReadyProductPieceComponent } from './Component/Auth/stock/ready-product-piece/ready-product-piece.component';
import { AdminPanelComponent } from './Component/Auth/Admin/admin-panel/admin-panel.component';
import { ProductTaggingListComponent } from './Component/Auth/tag/product-tagging-list/product-tagging-list.component';
import { PackagingStackFormComponent } from './Component/Auth/stock/packaging-stack-form/packaging-stack-form.component';
import { TagLabelsComponent } from './Component/Auth/tag/tag-labels/tag-labels.component';
import { GoldSilverStockListComponent } from './Component/Auth/list/gold-silver-stock-list/gold-silver-stock-list.component';
import { StockListComponent } from './Component/Auth/stock/stock-list/stock-list.component';
import { GoldStockListComponent } from './Component/Auth/list/gold-stock-list/gold-stock-list.component';
import { SilverStockListComponent } from './Component/Auth/list/silver-stock/silver-stock-list.component';
import { JewelleryPanelListComponent } from './Component/Auth/list/jewellery-panel-list/jewellery-panel-list.component';
import { PurchaseStockCategoryListListComponent } from './Component/Auth/list/purchase-stock-category-list-list/purchase-stock-category-list-list.component';
import { PurchaseStockListListComponent } from './Component/Auth/list/purchase-stock-list-list/purchase-stock-list-list.component';
import { WholesaleSearchListComponent } from './Component/Auth/list/wholesale-search-list/wholesale-search-list.component';
import { SoldOutStockListComponent } from './Component/Auth/list/sold-out-stock-list/sold-out-stock-list.component';
import { SoldOutStockList2ListComponent } from './Component/Auth/list/sold-out-stock-list2-list/sold-out-stock-list2-list.component';
import { RetailStockListListComponent } from './Component/Auth/list/retail-stock-list-list/retail-stock-list-list.component';
import { ImmitationRetailStockListComponent } from './Component/Auth/list/immitation-retail-stock-list/immitation-retail-stock-list.component';
import { ImmitationTotalAvailableStockListComponent } from './Component/Auth/list/immitation-total-available-stock-list/immitation-total-available-stock-list.component';
import { ImmitationPurchaseListComponent } from './Component/Auth/list/immitation-purchase-list/immitation-purchase-list.component';
import { ImmitationSterlingJewelleryPanelImageComponent } from './Component/Auth/list/immitation-sterling-jewellery-panel-image/immitation-sterling-jewellery-panel-image.component';
import { ImmitationSterlingJewelleryPanelListComponent } from './Component/Auth/list/immitation-sterling-jewellery-panel-list/immitation-sterling-jewellery-panel-list.component';
import { ImmitationWholesaleSearchImagesComponent } from './Component/Auth/list/immitation-wholesale-search-images/immitation-wholesale-search-images.component';
import { AllRawMetalStockListComponent } from './Component/Auth/list/all-raw-metal-stock-list/all-raw-metal-stock-list.component';
import { SellDetailsPanelComponent } from './Component/Auth/sells-panel/sell-details-panel/sell-details-panel.component';
import { PaymentDetailsComponent } from './Component/Auth/sells-panel/payment-details/payment-details/payment-details.component';
import { PaymentPanelComponent } from './Component/Auth/sells-panel/payment-details/payment-panel/payment-panel.component';
import { SellCustomerComponent } from './Component/Auth/sell-customer/sell-customer.component';
import { AddExpenseTypeComponent } from './Component/Auth/Admin/expense-type/add-expense-type.component';
import { DiamondStoneStockComponent } from './Component/Auth/stock/diamond-stone-stock/diamond-stone-stock.component';
import { CashDetailsComponent } from './Component/Auth/sells-panel/payment-details/cash-details/cash-details.component';
import { InvoicePanelComponent } from './Component/Auth/sells-panel/invoice-panel/invoice-panel.component';
import { InvoiceB2bComponent } from './Component/Auth/sells-panel/invoice-b2b/invoice-b2b.component';
import { InvoiceLayoutComponent } from './Component/Auth/sells-panel/invoice-layout/invoice-layout.component';
import { RateListInvoiceComponent } from './Component/Auth/rate-list/rate-list-invoice/rate-list-invoice.component';
import { FirmEditParentComponent } from './Component/Firm/firm-edit-parent/firm-edit-parent.component';
import { KalakarListComponent } from './Component/Auth/user/kalakar-list/kalakar-list.component';
import { RoughEstimateComponent } from './Component/Auth/sells-panel/rough-estimate/rough-estimate.component';
import { SellDetailsLotComponent } from './Component/Auth/sells-panel/sell-details-lot/sell-details-lot.component';
import { AddCategoryComponent } from './Component/Auth/Category/add-category/add-category.component';
import { AssemblyContainerComponent } from './Component/Auth/Assembly-Container/assembly-container/assembly-container.component';
import { AssemblyBrandComponent } from './Component/Auth/Assembly-Container/assembly-brand/assembly-brand.component';
import { AdminKalakarComponent } from './Component/Auth/user/admin-kalakar/admin-kalakar.component';
import { AssetsFormComponent } from './Component/Auth/Admin/assets-form/assets-form.component';
import { AssetsComponent } from './Component/Auth/kalakaar/assets/assets.component';
import { InvoiceListComponent } from './Component/Auth/invoices/invoice-list/invoice-list.component';
import { SetTypeComponent } from './Component/Auth/Admin/set-type/set-type.component';
import { CategoryParentComponent } from './Component/Auth/Category/category-parent/category-parent.component';
import { SubCategoryComponent } from './Component/Auth/Category/sub-category/sub-category.component';
import { WeighingScaleSettingComponent } from './Component/Auth/Admin/weighing-scale-setting/weighing-scale-setting.component';

import { AdminStaffListComponent } from './Component/Auth/Admin/admin-staff-list/admin-staff-list.component';
import { StockIssuedListComponent } from './Component/Auth/Admin/stock-issued-list/stock-issued-list.component';

import { NewStockComponent } from './Component/Auth/rmportal/new-stock/new-stock.component';
import { SalesHistoryComponent } from './Component/Auth/rmportal/sales-history/sales-history.component';
import { ExpenseComponent } from './Component/Auth/rmportal/expense/expense.component';
import { PendingPaymentComponent } from './Component/Auth/rmportal/home/pending-payment/pending-payment.component';
import { SoldStockComponent } from './Component/Auth/rmportal/sold-stock/sold-stock.component';
import { AddExpenseComponent } from './Component/Auth/rmportal/add-expense/add-expense.component';
import { InvoiceReportComponent } from './Component/Auth/sells-panel/invoice-report/invoice-report.component';
import { AdminDashboardComponent } from './Component/Admin-Dashboard/admin-dashboard/admin-dashboard.component';
import { BalanceSheetComponent } from './Component/Admin-Dashboard/Balance-Sheet/balance-sheet/balance-sheet.component';
import { ProfitLossSheetComponent } from './Component/Admin-Dashboard/PL-Sheet/profit-loss-sheet/profit-loss-sheet.component';
import { SalesDashboardComponent } from './Component/Admin-Dashboard/Sales/sales-dashboard/sales-dashboard.component';
import { StockDashboardComponent } from './Component/Admin-Dashboard/stock-dashboard/stock-dashboard.component';
import { AvailableStockComponent } from './Component/Auth/rmportal/available-stock/available-stock.component';
import { SubmittedStockComponent } from './Component/Auth/rmportal/submitted-stock/submitted-stock.component';

import { AccountsDashboardComponent } from './Component/Admin-Dashboard/Profit-Loss/accounts-dashboard/accounts-dashboard.component';
import { TopTenCustomersComponent } from './Component/Admin-Dashboard/Sales/top-ten-customers/top-ten-customers.component';
import { ProductWiseSaleComponent } from './Component/Admin-Dashboard/Sales/product-wise-sale/product-wise-sale.component';
import { NewAddedCategoriesComponent } from './Component/Admin-Dashboard/Sales/new-added-categories/new-added-categories.component';
import { UdharListComponent } from './Component/Admin-Dashboard/Profit-Loss/Udhar/udhar-list/udhar-list.component';
import { RateCutNoRateCutComponent } from './Component/Auth/sells-panel/payment-details/rate-cut-no-rate-cut/rate-cut-no-rate-cut.component';
import { AdminTagginglistComponent } from './Component/Auth/Admin/admin-tagginglist/admin-tagginglist.component';
import { StafflistAdminComponent } from './Component/Auth/Admin/stafflist-admin/stafflist-admin.component';
import { ParentStaffComponent } from './Component/Auth/Admin/parent-staff/parent-staff.component';
import { StaffAssetsComponent } from './Component/Auth/Admin/staff-assets/staff-assets.component';
import { DirectIssueComponent } from './Component/Auth/Admin/direct-issue/direct-issue.component';
import { AdminAccessControlComponent } from './Component/Auth/Admin/staff-access/admin-access-control/admin-access-control.component';
import { UdharReportComponent } from './Component/Auth/report/udhar-report/udhar-report.component';
import { ProductCategoryWiseSaleComponent } from './Component/Admin-Dashboard/Sales/product-category-wise-sale/product-category-wise-sale.component';
import { PackagingStackListComponent } from './Component/Auth/report/packaging-stack-list/packaging-stack-list.component';
import { IssueRawmaterialComponent } from './Component/Auth/stock/issue-rawmaterial/issue-rawmaterial.component';
import { OrderParentComponent } from './Component/Auth/stock/order-parent/order-parent.component';
import { SalesAnalysisComponent } from './Component/Auth/rmportal/sales-analysis/sales-analysis.component';
import { AssignHistoryComponent } from './Component/Auth/kalakaar/assign-history/assign-history.component';
import { RawMaterialReturnedListComponent } from './Component/Auth/stock/orders-creation/raw-material-returned-list/raw-material-returned-list.component';
import { CustomerManagementComponent } from './Component/Admin-Dashboard/customer-management/customer-management.component';
import { CustomerHomeComponent } from './Component/Admin-Dashboard/customer-home/customer-home.component';
import { InvoiceGstComponent } from './Component/Auth/sells-panel/invoice-gst/invoice-gst.component';
import { InvoiceGstPanelComponent } from './Component/Auth/sells-panel/invoice-gst-panel/invoice-gst-panel.component';
import { InvoiceGstHeaderComponent } from './Component/Auth/sells-panel/invoice-gst-header/invoice-gst-header.component';
import { PurchaseBillComponent } from './Component/Auth/sells-panel/purchase-bill/purchase-bill.component';
import { PurchaseBillReportComponent } from './Component/Auth/sells-panel/purchase-bill-report/purchase-bill-report.component';
import { GstBillReportComponent } from './Component/Auth/sells-panel/gst-bill-report/gst-bill-report.component';
import { WhatsappInstanceComponent } from './Component/Auth/Admin/whatsapp-instance/whatsapp-instance.component';
import { GstInvoiceCustomizationComponent } from './Component/Auth/sells-panel/gst-invoice-customization/gst-invoice-customization.component';
import { GstSettingsComponent } from './Component/Auth/sells-panel/gst-settings/gst-settings.component';
import { RoughEstimateCustomizationComponent } from './Component/Auth/sells-panel/rough-estimate-customization/rough-estimate-customization.component';
import { ReadyProductParentComponent } from './Component/Auth/report/ready-product-parent/ready-product-parent.component';
import { ReadyProductLotListComponent } from './Component/Auth/report/ready-product-lot-list/ready-product-lot-list.component';
import { AssemblyStockComponent } from './Component/Auth/report/assembly-stock/assembly-stock.component';
import { GstCustomerListComponent } from './Component/Auth/sells-panel/gst-customer-list/gst-customer-list.component';
import { CaAccountComponent } from './Component/Auth/sells-panel/ca-account/ca-account.component';
import { NonJewelleryProductComponent } from './Component/Auth/stock/non-jewellery-product/non-jewellery-product.component';
import { NonJewelleryProductListComponent } from './Component/Auth/stock/non-jewellery-product-list/non-jewellery-product-list.component';
import { AdminAssetsComponent } from './Component/Auth/Admin/admin-assets/admin-assets.component';
import { AccountLayoutComponent } from './Component/Auth/Accounts/account-layout/account-layout.component';
import { AddNewAccountComponent } from './Component/Auth/Accounts/add-new-account/add-new-account.component';
import { UpdateAllAccountsComponent } from './Component/Auth/Accounts/update-all-accounts/update-all-accounts.component';
import { UserAccountsComponent } from './Component/Auth/Accounts/user-accounts/user-accounts.component';
import { AccountBalanceComponent } from './Component/Auth/Accounts/account-balance/account-balance.component';
import { AccountsComponent } from './Component/Auth/Accounts/accounts/accounts.component';
import { DirectEntryComponent } from './Component/Auth/Accounts/direct-entry/direct-entry.component';
import { DaybookLayoutComponent } from './Component/Auth/Daybook/daybook-layout/daybook-layout.component';
import { BalanceSheetLayoutComponent } from './Component/Auth/Balance-sheet/balance-sheet-layout/balance-sheet-layout.component';
import { TrailBalanceComponent } from './Component/Auth/Trail-balance/trail-balance/trail-balance.component';
import { ProfitLossComponent } from './Component/Auth/Profit-loss/profit-loss/profit-loss.component';
import { LogsComponent } from './Component/Auth/Logs/logs/logs.component';
import { AccountLedgerComponent } from './Component/Auth/Accounts/account-ledger/account-ledger.component';


export const routes: Routes = [
  // Admin Dashboard
  //{ path: '', redirectTo: 'admin-dashboard', pathMatch: 'full' },
  { path: 'admin-dashboard', component: AdminDashboardComponent, canActivate: [authGuardGuard] },
  { path: 'sales-dashboard', component: SalesDashboardComponent, canActivate: [authGuardGuard] },
  { path: 'stock-dashboard', component: StockDashboardComponent, canActivate: [authGuardGuard] },
  { path: 'acccount-dashboard', component: AccountsDashboardComponent, canActivate: [authGuardGuard] },
  { path: 'staff-dashboard', component: StaffDashboardComponent, canActivate: [authGuardGuard] },
  // { path: 'balance-sheet', component: BalanceSheetComponent, canActivate: [authGuardGuard] },
  { path: 'profit-loss-sheet', component: ProfitLossSheetComponent, canActivate: [authGuardGuard] },
  { path: 'top-ten-customers', component: TopTenCustomersComponent, canActivate: [authGuardGuard] },
  { path: 'product-wise-sale', component: ProductWiseSaleComponent, canActivate: [authGuardGuard] },
  { path: 'new-added-categories', component: NewAddedCategoriesComponent, canActivate: [authGuardGuard] },
  { path: 'udhar-list', component: UdharListComponent, canActivate: [authGuardGuard] },
  { path: 'product-category-wise-sale', component: ProductCategoryWiseSaleComponent, canActivate: [authGuardGuard] },
  // { path: '**', redirectTo: 'admin-dashboard' },

  { path: 'login', component: LoginComponent },
  { path: 'signup', component: SignupComponent },
  { path: 'set-type', component: SetTypeComponent, canActivate: [authGuardGuard] },

  { path: '', component: HomeComponent, canActivate: [authGuardGuard] },
  { path: 'home', component: HomeComponent, canActivate: [authGuardGuard] },
  { path: 'user/create', component: UserCreateComponent, canActivate: [authGuardGuard] },
  { path: 'users', component: UserListComponent, canActivate: [authGuardGuard] },
  { path: 'user/:id/edit', component: UserEditComponent, canActivate: [authGuardGuard] },
  { path: 'countries', component: CountryShowComponent, canActivate: [authGuardGuard] },
  { path: 'countries/:id/edit', component: CountryEditComponent, canActivate: [authGuardGuard] },
  { path: 'countries/create', component: CountryCreateComponent, canActivate: [authGuardGuard] },
  { path: 'states', component: StatesShowComponent, canActivate: [authGuardGuard] },
  { path: 'states/:id/edit', component: StatesEditComponent, canActivate: [authGuardGuard] },
  { path: 'states/create', component: StatesCreateComponent, canActivate: [authGuardGuard] },
  { path: 'cities', component: CitiesShowComponent, canActivate: [authGuardGuard] },
  { path: 'cities/:id/edit', component: CitiesEditComponent, canActivate: [authGuardGuard] },
  { path: 'cities/create', component: CitiesCreateComponent, canActivate: [authGuardGuard] },

  { path: 'packages', component: PackageShowComponent, canActivate: [authGuardGuard] },
  { path: 'package/create', component: PackageCreateComponent, canActivate: [authGuardGuard] },
  { path: 'package/:id/edit', component: PackageEditComponent, canActivate: [authGuardGuard] },
  { path: 'packages/package/:id/details', component: SinglepackageShowComponent, canActivate: [authGuardGuard] },

  //owner related paths here
  { path: 'owners', component: OwnerShowComponent, canActivate: [authGuardGuard] },
  { path: 'owner/create', component: OwnerCreateComponent, canActivate: [authGuardGuard] },
  { path: 'owner/:id/edit', component: OwnerEditComponent, canActivate: [authGuardGuard] },
  { path: 'owner/:id/singleowner', component: OwnerSingleComponent, canActivate: [authGuardGuard] },

  { path: 'voucher', component: VoucherlistComponent, canActivate: [authGuardGuard] },
  { path: 'voucher/:id/edit', component: EditvoucherComponent, canActivate: [authGuardGuard] },
  { path: 'voucher/create', component: CreatevoucherComponent, canActivate: [authGuardGuard] },
  { path: 'voucher/:id/singlevoucher', component: SinglevoucherComponent, canActivate: [authGuardGuard] },

  { path: 'forgot-password', component: ForgotPasswordComponent },
  { path: 'verify-otp', component: VerifyOtpComponent },
  { path: 'update-password', component: UpdatePasswordComponent },
  { path: 'validate-otp', component: ValidateOtpComponent },
  { path: 'layout', component: UnauthenticatedLayoutComponent },

  { path: 'firm/:id/edit', component: FirmEditParentComponent, canActivate: [authGuardGuard] },

  { path: 'firm-list', component: FirmListComponent, canActivate: [authGuardGuard] },
  { path: 'firm-create', component: FirmCreateComponent, canActivate: [authGuardGuard] },

  {
    path: 'add-stock', component: AddStockComponent, canActivate: [authGuardGuard],
    children: [
      { path: 'add-retail-fine-stock-b1', component: AddFineStockB1Component, canActivate: [authGuardGuard] },
      { path: 'add-retail-fine-stock-b2', component: AddFineStockB2Component, canActivate: [authGuardGuard] },
      { path: 'add-retail-fine-stock-b3', component: AddFineStockB3Component, canActivate: [authGuardGuard] },

      { path: 'add-cad-stock', component: AddCadStockComponent, canActivate: [authGuardGuard] },
      { path: 'add-metal-form-b2', component: AddMetalFormB2Component, canActivate: [authGuardGuard] },
      { path: 'add-wholesale-fine-stock-b1', component: AddWholesaleStockB1Component, canActivate: [authGuardGuard] },
      { path: 'add-wholesale-fine-stock-b2', component: AddWholesaleStockB2Component, canActivate: [authGuardGuard] },
      { path: 'add-wholesale-fine-stock-b3', component: AddWholesaleStockB3Component, canActivate: [authGuardGuard] },
      { path: 'add-retail-fine-stock-b1-scroll', component: AddFineStockB1ScrollComponent, canActivate: [authGuardGuard] },
      { path: 'add-retail-imitation-stock-b1', component: ImitationStockB1Component, canActivate: [authGuardGuard] },

      { path: 'add-retail-imitation-stock-b2', component: ImitationStockB2Component, canActivate: [authGuardGuard] },
      { path: 'add-retail-imitation-stock-b3', component: ImitationStockB3Component, canActivate: [authGuardGuard] },

      { path: 'add-retail-imitation-fashion-jewellery', component: ImitationFashionJewelleryComponent, canActivate: [authGuardGuard] },

      { path: 'add-retail-add-sterling-jewellery-stock', component: AddSterlingJewelleryStockComponent, canActivate: [authGuardGuard] },
      { path: '', redirectTo: 'add-retail-fine-stock-b1', pathMatch: 'full' },


      // wholsale-imitation-stock

      { path: 'add-wholsale-imitation-stock-b1', component: WholsaleImitationStockB1Component, canActivate: [authGuardGuard] },
      { path: 'add-wholsale-imitation-stock-b2', component: WholsaleImitationStockB2Component, canActivate: [authGuardGuard] },
      { path: 'add-wholsale-imitation-stock-b3', component: WholsaleImitationStockB3Component, canActivate: [authGuardGuard] },
      { path: 'add-wholsale-imitation-fashion-jewellery', component: WholsaleImitationFashionJewelleryComponent, canActivate: [authGuardGuard] },
      { path: 'add-wholsale-imitation-add-sterling-jewellery', component: WholsaleImitationAddSterlingJewelleryStockComponent, canActivate: [authGuardGuard] },


      //  { path: 'add-raw-metal-stock', component: RawMetalStockComponent, canActivate: [authGuardGuard] },
      { path: 'raw-metal-stock', component: RawMetalStockComponent },
      { path: 'diamond-stone-stock', component: DiamondStoneStockComponent }


    ]
  },
  { path: 'issued-stock', component: StockIssuedListComponent, canActivate: [authGuardGuard] },
  { path: '', redirectTo: 'add-stock', pathMatch: 'full' },
  {
    path: 'admin-panel', component: AdminPanelComponent, canActivate: [authGuardGuard],
    children: [
      {
        path: 'category-parent', component: CategoryParentComponent, canActivate: [authGuardGuard],
        children: [
          { path: 'add-category', component: AddCategoryComponent, canActivate: [authGuardGuard] },
          { path: 'sub-category', component: SubCategoryComponent, canActivate: [authGuardGuard] },
          { path: 'assembly_brand', component: AssemblyBrandComponent, canActivate: [authGuardGuard] },
          { path: '', redirectTo: 'add-category', pathMatch: 'full' },
        ]
      },
      { path: 'admintagginglist/:staffId/:staffName', component: AdminTagginglistComponent, canActivate: [authGuardGuard] },
      { path: 'adminkalakar/:staffId/:staffName', component: AdminKalakarComponent, canActivate: [authGuardGuard] },

      { path: 'stafflistadmin', component: StafflistAdminComponent, canActivate: [authGuardGuard] },
      {
        path: 'staff/:staffId', component: ParentStaffComponent, canActivate: [authGuardGuard],
        children: [
          { path: 'issue-stock', component: AdminTagginglistComponent, canActivate: [authGuardGuard] },
          // { path: 'assign-assets', component: StaffAssetsComponent, canActivate: [authGuardGuard] },
          { path: 'assign-assets', component: AdminAssetsComponent, canActivate: [authGuardGuard] },
          { path: 'direct-issue', component: DirectIssueComponent, canActivate: [authGuardGuard] },
          { path: 'user-access', component: AdminAccessControlComponent, canActivate: [authGuardGuard] }
        ]
      },


      { path: 'taglist/:staffId/:staffName', component: ProductTaggingListComponent, canActivate: [authGuardGuard] },

      { path: 'dropdown-setting', component: DropdownSettingComponent, canActivate: [authGuardGuard] },
      { path: 'list-kalakar', component: KalakarListComponent, canActivate: [authGuardGuard] },
      { path: 'admin-kalakar', component: AdminKalakarComponent, canActivate: [authGuardGuard] },
      { path: 'set-type', component: SetTypeComponent, canActivate: [authGuardGuard] },
      { path: 'expense-type', component: AddExpenseTypeComponent, canActivate: [authGuardGuard] },
      { path: 'admin-customize-invoice', component: InvoiceLayoutComponent, canActivate: [authGuardGuard] },
      { path: 'asset-form', component: AssetsFormComponent, canActivate: [authGuardGuard] },
      // { path: 'user-list/staff-list', component: StaffListComponent, canActivate: [authGuardGuard] },
      // { path: 'user-access/:id', component: AdminAccessControlComponent, canActivate: [authGuardGuard] },
      { path: 'rate-List', component: RateListGeneratorComponent, canActivate: [authGuardGuard] },
      { path: 'whatsapp-instance', component: WhatsappInstanceComponent, canActivate: [authGuardGuard] },
      { path: 'generated-rate-list', component: GeneratedRatelistComponent, canActivate: [authGuardGuard], data: { role: 'Owner' } },
      { path: 'rough-estimate-customization', component: RoughEstimateCustomizationComponent, canActivate: [authGuardGuard] },
      // weighing scale setting route 
      { path: 'weighing-scale-setting', component: WeighingScaleSettingComponent, canActivate: [authGuardGuard] },
      // { path: '', redirectTo: 'set-type', pathMatch: 'full' },


    ]
  },
  { path: '', redirectTo: 'admin-panel', pathMatch: 'full' },
  { path: 'udhar-report', component: UdharReportComponent, canActivate: [authGuardGuard] },

  { path: 'invoice-report', component: InvoiceReportComponent, canActivate: [authGuardGuard] },
  {
    path: 'report', component: CreateReportComponent, canActivate: [authGuardGuard],
    children: [
      { path: 'fine-jewellery', component: FineJewelleryComponent, canActivate: [authGuardGuard] },
      { path: 'gold-silver-stock', component: GoldSilverStockListComponent, canActivate: [authGuardGuard] },
      { path: 'gold-stock', component: GoldStockListComponent, canActivate: [authGuardGuard] },
      { path: 'silver-stock', component: SilverStockListComponent, canActivate: [authGuardGuard] },
      { path: 'jewellery-panel-list', component: JewelleryPanelListComponent, canActivate: [authGuardGuard] },
      { path: 'purchase-stock-category-list-list', component: PurchaseStockCategoryListListComponent, canActivate: [authGuardGuard] },
      { path: 'purchase-stock-list-list', component: PurchaseStockListListComponent, canActivate: [authGuardGuard] },
      { path: 'wholesale-search-list', component: WholesaleSearchListComponent, canActivate: [authGuardGuard] },
      { path: 'sold-out-stock-list', component: SoldOutStockListComponent, canActivate: [authGuardGuard] },
      { path: 'sold-out-stock-list2-list', component: SoldOutStockList2ListComponent, canActivate: [authGuardGuard] },
      { path: 'retail-stock-list-list', component: RetailStockListListComponent, canActivate: [authGuardGuard] },
      { path: 'imitation-jewellery', component: ImitationJewelleryComponent, canActivate: [authGuardGuard] },
      { path: 'immitation-retail-stock-list', component: ImmitationRetailStockListComponent, canActivate: [authGuardGuard] },
      { path: 'immitation-total-available-stock-list', component: ImmitationTotalAvailableStockListComponent, canActivate: [authGuardGuard] },
      { path: 'immitation-purchase-list', component: ImmitationPurchaseListComponent, canActivate: [authGuardGuard] },
      { path: 'immitation-sterling-jewellery-panel-image', component: ImmitationSterlingJewelleryPanelImageComponent, canActivate: [authGuardGuard] },
      { path: 'immitation-sterling-jewellery-panel-list', component: ImmitationSterlingJewelleryPanelListComponent, canActivate: [authGuardGuard] },
      { path: 'immitation-wholesale-search-images', component: ImmitationWholesaleSearchImagesComponent, canActivate: [authGuardGuard] },
      { path: 'raw-metal', component: RawMetalComponent, canActivate: [authGuardGuard] },
      { path: 'raw-metal-stock', component: RawMetalListComponent, canActivate: [authGuardGuard] },
      { path: 'raw-stone-stock-list', component: RawStoneListComponent, canActivate: [authGuardGuard] },
      { path: 'all-raw-metal-stock-list', component: AllRawMetalStockListComponent, canActivate: [authGuardGuard] },
      { path: 'stone-stock', component: RawStoneListComponent, canActivate: [authGuardGuard] },
      { path: 'stock-tally', component: StockTallyComponent, canActivate: [authGuardGuard] },
      { path: 'general-list', component: GeneralListComponent, canActivate: [authGuardGuard] },
      { path: 'ready-products', component: ReadyProductParentComponent, canActivate: [authGuardGuard], },
      { path: 'ready-products/piece', component: ReadyProductListComponent, canActivate: [authGuardGuard] },
      { path: 'ready-products/lot', component: ReadyProductLotListComponent, canActivate: [authGuardGuard] },
      { path: 'non-jewellery-product-list', component: NonJewelleryProductListComponent, canActivate: [authGuardGuard] },
      { path: 'reorder-list', component: ReorderListComponent, canActivate: [authGuardGuard] },
      { path: 'other-panel', component: OtherPanelComponent, canActivate: [authGuardGuard] },
      { path: 'stock-ins', component: StockInListComponent, canActivate: [authGuardGuard] },
      { path: 'stock-outs', component: StockOutListComponent, canActivate: [authGuardGuard] },
      { path: 'stock-list', component: StockListComponent, canActivate: [authGuardGuard] },
      { path: 'assemblystock-list', component: AssemblyStockComponent, canActivate: [authGuardGuard] },
      { path: 'stock-packaging-list', component: PackagingListComponent, canActivate: [authGuardGuard] },
      { path: 'packaging-stack-list', component: PackagingStackListComponent, canActivate: [authGuardGuard] },
      { path: '', redirectTo: 'raw-metal', pathMatch: 'full' }
    ]
  },
  { path: 'expense', component: ExpenseComponent, canActivate: [authGuardGuard] },
  { path: 'add-expense', component: AddExpenseComponent, canActivate: [authGuardGuard] },
  { path: 'edit-expense/:id', component: AddExpenseComponent, canActivate: [authGuardGuard] },
  { path: 'direct-entry', component: DirectEntryComponent, canActivate: [authGuardGuard] },
  { path: '', redirectTo: 'report', pathMatch: 'full' },

  { path: 'sell', component: SellComponent, canActivate: [authGuardGuard] },
  { path: 'sell-details', component: SellDetailsPanelComponent, canActivate: [authGuardGuard] },
  { path: 'sell-details/:id', component: SellDetailsPanelComponent, canActivate: [authGuardGuard] },

  { path: 'sell-details/customer/:id/sell-details', component: SellDetailsPanelComponent, canActivate: [authGuardGuard] },
  { path: 'sell-details-lot/:id', component: SellDetailsLotComponent, canActivate: [authGuardGuard] },
  { path: 'payment-details', component: PaymentDetailsComponent, canActivate: [authGuardGuard] },
  { path: 'payment-details/:id', component: PaymentDetailsComponent, canActivate: [authGuardGuard] },
  { path: 'payment-panel', component: PaymentPanelComponent, },
  { path: 'rate-cut-no-rate-cut', component: RateCutNoRateCutComponent, },

  // {path: 'payment-details', component: PaymentDetailsComponent, canActivate: [authGuardGuard],
  //   children: [
  //     {path: 'payment-panereport/gold-stockl', component: PaymentPanelComponent, canActivate: [authGuardGuard]},
  //     {path: 'cash-details', component: CashDetailsComponent, canActivate: [authGuardGuard]},
  //   ]
  // },

  {
    path: 'invoice-panel', component: InvoicePanelComponent, canActivate: [authGuardGuard]
  },
  { path: 'admin-customize-invoice', component: InvoiceLayoutComponent, canActivate: [authGuardGuard] },
  {
    path: 'invoice-b2b/:id', component: InvoiceB2bComponent, canActivate: [authGuardGuard]
  },
  { path: 'rough-estimate-invoice/:id', component: RoughEstimateComponent, canActivate: [authGuardGuard] },
  {
    path: 'invoice-panel/:id', component: InvoicePanelComponent, canActivate: [authGuardGuard]
  },

  {
    path: 'cash-details', component: CashDetailsComponent, canActivate: [authGuardGuard]
  },
  {
    path: 'payment-details',
    component: PaymentDetailsComponent,
    canActivate: [authGuardGuard],
    children: [
      {
        path: '',
        redirectTo: 'payment-panel',
        pathMatch: 'full'
      },
      {
        path: 'payment-panel',
        component: PaymentPanelComponent,
        canActivate: [authGuardGuard]
      },
      {
        path: 'cash-details',
        component: CashDetailsComponent,
        canActivate: [authGuardGuard]
      }
    ]
  },


  {
    path: 'create-user', component: CreateUserComponent, canActivate: [authGuardGuard],
    children: [
      { path: 'add-customer', component: AddCustomerComponent, canActivate: [authGuardGuard] },
      { path: 'add-customer/:id', component: AddCustomerComponent, canActivate: [authGuardGuard] },
      { path: 'add-staff', component: AddStaffComponent, canActivate: [authGuardGuard] },
      { path: 'add-staff/:id', component: AddStaffComponent, canActivate: [authGuardGuard] },
      { path: 'add-supplier', component: AddSupplierComponent, canActivate: [authGuardGuard] },
      { path: 'add-supplier/:id', component: AddSupplierComponent, canActivate: [authGuardGuard] },
      { path: 'add-investor', component: AddInvestorComponent, canActivate: [authGuardGuard] },
      { path: 'add-investor/:id', component: AddInvestorComponent, canActivate: [authGuardGuard] },
      { path: '', redirectTo: 'add-customer', pathMatch: 'full' }

    ]
  },
  { path: '', redirectTo: 'create-user', pathMatch: 'full' },

  {
    path: 'user-list', component: AlluserListComponent, canActivate: [authGuardGuard],
    children: [
      { path: 'customer-list', component: CustomerListComponent, canActivate: [authGuardGuard] },
      { path: 'staff-list', component: StaffListComponent, canActivate: [authGuardGuard] },
      { path: 'supplier-list', component: SupplierListComponent, canActivate: [authGuardGuard] },
      { path: 'investor-list', component: InvestorListComponent, canActivate: [authGuardGuard] },
      { path: '', redirectTo: 'customer-list', pathMatch: 'full' }
    ]
  },
  { path: '', redirectTo: 'user-list', pathMatch: 'full' },
  { path: 'invoice-list', component: InvoiceListComponent, canActivate: [authGuardGuard] },

  { path: 'file-upload', component: TestFileUploadComponent, canActivate: [authGuardGuard] },

  { path: 'stock-feature', component: StockFeatureComponent, canActivate: [authGuardGuard] },
  {
    path: 'add-ready-product', component: AddReadyProductComponent, canActivate: [authGuardGuard],
    children: [
      { path: 'piece', component: ReadyProductPieceComponent, canActivate: [authGuardGuard] },
      { path: 'piece/:id', component: ReadyProductPieceComponent, canActivate: [authGuardGuard] },
      { path: 'lot', component: ReadyProductLotComponent, canActivate: [authGuardGuard] },
      { path: 'lot/:id', component: ReadyProductLotComponent, canActivate: [authGuardGuard] },
      { path: 'non-jewellery-product', component: NonJewelleryProductComponent, canActivate: [authGuardGuard] },
      { path: 'non-jewellery-product/:id', component: NonJewelleryProductComponent, canActivate: [authGuardGuard] },
      { path: '', redirectTo: 'piece', pathMatch: 'full' }
    ]
  },
  { path: '', redirectTo: 'add-ready-product', pathMatch: 'full' },
  { path: 'add-ready-product', component: AddReadyProductComponent, canActivate: [authGuardGuard] },
  { path: 'rate-list-invoice', component: RateListInvoiceComponent, canActivate: [authGuardGuard], data: { role: 'Owner' } },
  {
    path: 'rate-list/print/:id',
    component: RateListInvoiceComponent,
    canActivate: [authGuardGuard],
  },
  {
    path: 'raw-metal', component: RawMetalEntryComponent, canActivate: [authGuardGuard],
    children: [

      { path: 'metal', component: MetalComponent, canActivate: [authGuardGuard] },
      { path: 'metal/:id', component: MetalComponent, canActivate: [authGuardGuard] },
      { path: 'stone', component: StoneComponent, canActivate: [authGuardGuard] },
      { path: 'stone/:id', component: StoneComponent, canActivate: [authGuardGuard] },
      { path: '', redirectTo: 'metal', pathMatch: 'full' }
    ]
  },
  { path: '', redirectTo: 'raw-metal', pathMatch: 'full' },

  { path: 'general-list', component: GeneralListComponent, canActivate: [authGuardGuard] },

  {
    path: 'create-tag', component: CreateTagComponent, canActivate: [authGuardGuard],
    children: [
      { path: 'assemble-product', component: AssembleProductComponent, canActivate: [authGuardGuard] },
      { path: 'fine-product', component: FineProductComponent, canActivate: [authGuardGuard] },
      { path: '', redirectTo: 'assemble-product', pathMatch: 'full' }
    ]
  },
  { path: '', redirectTo: 'create-tag', pathMatch: 'full' },

  {
    path: 'tag-list', component: TagListComponent, canActivate: [authGuardGuard],
    children: [
      { path: 'assemble-taglist', component: AssembleTaglistComponent, canActivate: [authGuardGuard] },
      { path: 'fine-taglist', component: FineTaglistComponent, canActivate: [authGuardGuard] },
      { path: '', redirectTo: 'assemble-taglist', pathMatch: 'full' }
    ]
  },
  { path: '', redirectTo: 'tag-list', pathMatch: 'full' },

  { path: 'error-403', component: ForbiddenComponent, canActivate: [authGuardGuard] },

  { path: 'categories-list', component: CategoriesListComponent, canActivate: [authGuardGuard] },

  {
    path: 'rm-portal', component: StaffDashboardComponent, canActivate: [authGuardGuard],
    children: [
      // {
      //   path: 'home', component: StaffHomeComponent, canActivate: [authGuardGuard],
      //   children: [
      //     { path: 'top-details', component: TopDetailsComponent, canActivate: [authGuardGuard] },
      //     { path: 'sales-target', component: SalesTargetComponent, canActivate: [authGuardGuard] },
      //     { path: 'stock-overview', component: StockOverviewComponent, canActivate: [authGuardGuard] },
      //   ]
      // },
      { path: 'home', component: SalesAnalysisComponent },
      { path: 'sell-customer', component: SellCustomerComponent, canActivate: [authGuardGuard] },
      { path: 'new-stock', component: NewStockComponent, canActivate: [authGuardGuard] },
      { path: 'available-stock', component: AvailableStockComponent, canActivate: [authGuardGuard] },
      { path: 'submitted-stock', component: SubmittedStockComponent, canActivate: [authGuardGuard] },
      { path: 'sold-stock', component: SoldStockComponent, canActivate: [authGuardGuard] },
      { path: 'assets', component: AssetsComponent, canActivate: [authGuardGuard] },
      { path: 'sales-history', component: SalesHistoryComponent, canActivate: [authGuardGuard] },
      { path: 'incentive', component: IncentivesComponent, canActivate: [authGuardGuard] },
      { path: 'udhar', component: PendingPaymentComponent, canActivate: [authGuardGuard] },
      { path: 'expense', component: ExpenseComponent, canActivate: [authGuardGuard] },
      { path: 'edit-expense/:id', component: AddExpenseComponent, canActivate: [authGuardGuard] },
      { path: 'add-expense', component: AddExpenseComponent, canActivate: [authGuardGuard] },
      { path: 'user-list/customer-list', component: CustomerListComponent, canActivate: [authGuardGuard] },
      { path: 'add-customer', component: AddCustomerComponent, canActivate: [authGuardGuard] },
      { path: '', redirectTo: 'home', pathMatch: 'full' }
    ]
  },

  { path: 'customize-form', component: CustomizeFormComponent, canActivate: [authGuardGuard] },

  { path: 'product-creation', component: ProductCreationComponent, canActivate: [authGuardGuard] },
  { path: 'product-creation/:id', component: ProductEditComponent, canActivate: [authGuardGuard] },
  { path: 'ready-product-list', component: ReadyProductListComponent, canActivate: [authGuardGuard] },
  { path: 'raw-metal-list', component: RawMetalListComponent, canActivate: [authGuardGuard] },
  { path: 'raw-stone-list', component: RawStoneListComponent, canActivate: [authGuardGuard] },
  { path: 'available-retail-stock-list', component: AvailableRetailStockListComponent, canActivate: [authGuardGuard] },
  { path: 'dropdown-settings', component: DropdownSettingComponent, canActivate: [authGuardGuard], data: { role: 'Owner' } },
  { path: 'packaging-form', component: PackagingFormComponent, canActivate: [authGuardGuard] },
  { path: 'packaging-form/:id', component: PackagingFormComponent, canActivate: [authGuardGuard] },
  { path: 'packaging-stack-form', component: PackagingStackFormComponent, canActivate: [authGuardGuard] },
  { path: 'packaging-stack-form/:id', component: PackagingStackFormComponent, canActivate: [authGuardGuard] },
  { path: 'stock-ins', component: StockInListComponent, canActivate: [authGuardGuard] },
  { path: 'stock-outs', component: StockOutListComponent, canActivate: [authGuardGuard] },
  { path: 'assigne-list', component: AssigneComponent, canActivate: [authGuardGuard] },
  {
    path: 'order',
    component: OrderParentComponent,
    canActivate: [authGuardGuard],
    children: [
      {
        path: '',
        redirectTo: 'order-creation',
        pathMatch: 'full',
      },
      {
        path: 'order-creation',
        component: OrdersCreationComponent,
      },
      {
        path: 'issue-raw-material',
        component: IssueRawmaterialComponent,
      },
    ],
  },



  { path: 'raw-material-returned-list', component: RawMaterialReturnedListComponent, canActivate: [authGuardGuard] },
  //{ path: 'order-creation', component: OrderCreationComponent, canActivate: [authGuardGuard] },
  //{ path: 'orders-creation', component: OrdersCreationComponent, canActivate: [authGuardGuard] },
  { path: 'orders-creation/:id', component: OrdersCreationComponent, canActivate: [authGuardGuard] },
  { path: 'design-product', component: DesignProductComponent, canActivate: [authGuardGuard] },
  {
    path: 'kalakaar-management', component: KalakaarManagementComponent, canActivate: [kalakarGuard], data: { role: 'Staff', sub_role: 'Karigar' },
    children: [
      { path: 'home', component: KalakaarHomeComponent, canActivate: [kalakarGuard] },
      { path: 'order', component: OrderComponent, canActivate: [kalakarGuard] },
      { path: 'raw-material', component: RawMaterialComponent, canActivate: [kalakarGuard] },
      { path: 'account', component: AccountComponent, canActivate: [kalakarGuard] },
      { path: 'order/:id/assign-history', component: AssignHistoryComponent, canActivate: [kalakarGuard] },
      { path: '', redirectTo: 'home', pathMatch: 'full' }
    ]
  },

  {
    path: 'customer-management',
    component: CustomerManagementComponent,
    canActivate: [authGuardGuard],
    data: { role: 'Staff', sub_role: 'Customer' },
    children: [
      {
        path: 'home',
        component: CustomerHomeComponent,
        canActivate: [authGuardGuard],
        data: { role: 'Staff', sub_role: 'Customer' }
      },
      {
        path: 'orders',
        component: OrderCreationComponent,
        canActivate: [authGuardGuard],
        data: { role: 'Staff', sub_role: 'Customer' }
      },
      { path: '', redirectTo: 'home', pathMatch: 'full' }
    ]
  },
  { path: 'invoice-gst/:id', component: InvoiceGstComponent, canActivate: [authGuardGuard] },
  { path: 'gst-customer-list', component: GstCustomerListComponent, canActivate: [authGuardGuard] },
  { path: 'invoice-gst-panel', component: InvoiceGstPanelComponent, canActivate: [authGuardGuard] },
  { path: 'purchase-bill', component: PurchaseBillComponent, canActivate: [authGuardGuard] },
  { path: 'purchase-report', component: PurchaseBillReportComponent, canActivate: [authGuardGuard] },
  { path: 'gst-settings/gst-inv-layout-settings', component: GstInvoiceCustomizationComponent, canActivate: [authGuardGuard] },
  { path: 'gst-bill-report', component: GstBillReportComponent, canActivate: [authGuardGuard] },
  { path: 'gst-settings', component: GstSettingsComponent, canActivate: [authGuardGuard], },
  { path: 'gst-settings/whatsapp-instance', component: WhatsappInstanceComponent, canActivate: [authGuardGuard] },
  { path: 'available-to-produce', component: AvailableToProduceComponent, canActivate: [authGuardGuard] },
  { path: 'material-requirement-sheet', component: MaterialRequirementSheetComponent, canActivate: [authGuardGuard] },
  { path: 'combo-creation', component: ComboCreationComponent, canActivate: [authGuardGuard] },
  { path: 'product-tagging', component: ProductTaggingComponent, canActivate: [authGuardGuard] },
  { path: 'admin-panel', component: AdminPanelComponent, canActivate: [authGuardGuard], data: { role: 'Owner' } },
  { path: 'taggings-list', component: ProductTaggingListComponent, canActivate: [authGuardGuard] },
  { path: 'tag-labels', component: TagLabelsComponent, canActivate: [authGuardGuard] },
  { path: 'kalakar-list', component: KalakarListComponent, canActivate: [authGuardGuard] },
  { path: 'admin-kalakar', component: AdminKalakarComponent, canActivate: [authGuardGuard] },
  { path: 'adminstaff-list', component: AdminStaffListComponent, canActivate: [authGuardGuard] },
  { path: 'customer-dashboard/:id', component: CustomerHomeComponent, canActivate: [authGuardGuard] },


  //Chartered Accountant — unique CA-only route
  { path: 'ca-account', component: CaAccountComponent, canActivate: [authGuardGuard] },

  // Accounts
  {
    path: 'accounts', component: AccountLayoutComponent, canActivate: [authGuardGuard],
    children: [
      { path: 'add-new-account', component: AddNewAccountComponent },
      { path: 'update-all-accounts', component: UpdateAllAccountsComponent },
      { path: 'user-accounts', component: UserAccountsComponent },
      { path: 'account-balance', component: AccountBalanceComponent },
      { path: '', component: AccountsComponent },
    ],
  },
  { path: 'account-ledger', component: AccountLedgerComponent, canActivate: [authGuardGuard] },

  //Daybook
  { path: 'daybook', component: DaybookLayoutComponent, canActivate: [authGuardGuard] },
  { path: 'daybook/:tab', component: DaybookLayoutComponent, canActivate: [authGuardGuard] },
  // Trail Balance
  { path: 'trail-balance', component: TrailBalanceComponent, canActivate: [authGuardGuard] },
  // Balance Sheet
  { path: 'balance-sheet', component: BalanceSheetLayoutComponent, canActivate: [authGuardGuard] },
  // Profit & Loss
  { path: 'profit-loss', component: ProfitLossComponent, canActivate: [authGuardGuard] },
  // Logs
  { path: 'logs', component: LogsComponent, canActivate: [authGuardGuard] },

  { path: '**', component: NotFoundComponent, canActivate: [authGuardGuard] },

];
